import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: { laws: [], totalLaws: 0 },
  mutations: {
    setLaws(state, laws) {
      state.laws = laws;
    },
    setTotalLaws(state, totalLaws) {
      state.totalLaws = totalLaws;
    },
  },
  actions: {
    async getLaws({ commit }) {
      const response = await axios.get(
        "items/leis?fields=id_lei,numero_lei,data_lei,nome_lei&limit=-1&sort=-data_lei"
      );

      commit("setLaws", response.data.data);
      commit("setTotalLaws", response.data.data.length);
    },
  },
});

export default store;

